import { render, staticRenderFns } from "./ViStudentHome.vue?vue&type=template&id=62c76498&scoped=true"
import script from "./ViStudentHome.vue?vue&type=script&lang=js"
export * from "./ViStudentHome.vue?vue&type=script&lang=js"
import style0 from "./ViStudentHome.vue?vue&type=style&index=0&id=62c76498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c76498",
  null
  
)

export default component.exports